import Vue from 'vue'
import Router from 'vue-router'

import ProgressBar from '@shared/progress-bar/progress-bar'

import Layout from './components/Layout.vue'

import Home from './views/Home.vue'
import Inscriptions from './views/Inscriptions.vue'
import Error404 from './views/Error404.vue'

const router = new Router({
  routes: [
    {
      path: '/:slug?',
      component: Layout,
      children: [{
        path: '',
        name: 'home',
        component: Home,
      }, {
        path: 'program/:programId',
        name: 'program',
        component: Inscriptions,
      }]
    },
    {
      path: '*',
      component: Error404
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name) ProgressBar.start()
  next()
});

router.afterEach(() => {
  ProgressBar.done()
});

Vue.use(Router)

export default router